<template>
    <div id="landing-page">
        <landing-menu></landing-menu>
        <div class="wrap">
            <router-view ></router-view>
        </div>
        <biz-footer v-if="$route.name === 'bizIntro'"></biz-footer>
        <landing-footer v-else></landing-footer>
    </div>
</template>
<script>
import landingMenu from '@/components/officailPage/widges/menu/menu.vue';
import landingFooter from '@/components/officailPage/widges/footer.vue';
import bizFooter from '@/components/officailPage/widges/bizFooter.vue';

export default {
    mounted () {
        console.log(this.$route.name)
        // 有token自動導頁到各自首頁
        let routeName = this.$route.name
        if(
            routeName !== 'bizUserTerms' &&
            routeName !== 'bizPrivacyPolicy' &&
            routeName !== 'privacyPolicy' &&
            routeName !== 'userTerms' 
        ){
            this.$store.dispatch('autoRedirect')
        }
    },
    components: {
        landingMenu,
        landingFooter,
        bizFooter
    }
}
</script>
<style lang="scss" scoped>
    // @import "../../../static/css/landing.scss";
    #landing-page{
        position: relative;
        .wrap{
            position: relative;
        }
        
    }
</style>


// WEBPACK FOOTER //
// src/pages/officailPage/landingPage.vue